import { createRequestAtom } from '../utils/request-atom';
import { GetEnterpriseAnalyticsEmbedLinkResponse } from '../../modules/app/typings';

export const enterpriseAnalyticsDetailsAtom = createRequestAtom<
  GetEnterpriseAnalyticsEmbedLinkResponse | undefined
>(undefined);
